import { render, staticRenderFns } from "./DateBasedTasks.vue?vue&type=template&id=426dce5e&"
import script from "./DateBasedTasks.vue?vue&type=script&lang=js&"
export * from "./DateBasedTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports